<template>
  <div class="app-review-star-rating__container">
    <app-review-star
      v-for="index in 5"
      :key="index"
      :star-type="starTypeForIndex(index)"
    />
  </div>
</template>

<script>
import AppReviewStar from './AppReviewStar'

export default {
  name: 'AppReviewStarRating',
  components: {
    AppReviewStar
  },
  props: {
    rating: {
      type: Number,
      validation (newRating) {
        return newRating >= 0.0 && newRating <= 5.0
      },
      default: 5.0
    }
  },
  methods: {
    starTypeForIndex (index) {
      if (index <= Math.floor(this.rating)) {
        return 'full'
      } else if (index % 1 > 0) {
        return 'empty'
      }
      return 'half'
    }
  }
}
</script>

<style scoped>
.app-review-star-rating__container {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  height: 1.5rem;
  width: fit-content;
}
</style>
